import styled from 'styled-components';

export default styled.div`
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
  padding-bottom: 30px;
`;

export const SearchWrapSC = styled.div`
  width: 100%;
`;

export const FaqsResultsBodySC = styled.div`
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding-top: 60px;
  max-width: 577px;
  margin: 0 auto;
  .result-text {
    padding-bottom: 30px;
  }
`;

export const FaqsHeadlineSC = styled.h2`
  font-size: 34px;
  font-weight: bold;
  line-height: auto;
  width: 100%;
  margin-bottom: 0px;
`;

export const EmptyResultsSC = styled.div`
  width: 100%;
  max-width: 480px;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;

  .not-find-text {
    padding-top: 32px;
    padding-bottom: 8px;
    font-size: 20px;
    font-weight: bold;
  }
  .result-text {
    font-size: 16px;
    font-weight: normal;
    padding: 10px 0;
    width: 100%;
    border-bottom: 1px solid #e9e9e9;
    text-decoration: none;
  }
  button {
    margin-left: 8px;
  }
`;
